import { EntityCombobox } from "@/components/EntityCombobox";
import { apiClient } from "@/lib/apiClient";
import { buscarLookup, type LookupItem } from "@/lib/consultas";

const BASE = "/api/compras/fornecedores";

interface FornecedorDetalheApi {
  id: number;
  nomeRazao: string;
  cpfCnpj?: string | null;
}

async function obterFornecedor(id: number): Promise<LookupItem> {
  const { data } = await apiClient.get<FornecedorDetalheApi>(`${BASE}/${id}`);
  return { id: data.id, codigo: String(data.id), descricao: data.nomeRazao, extra: data.cpfCnpj };
}

interface FornecedorComboboxProps {
  value?: number | null;
  onChange?: (id: number | null) => void;
  onSelect?: (item: LookupItem | null) => void;
  /** Nome já conhecido (DTO em edição): exibe sem GET e mesmo se a pessoa não for mais fornecedor. */
  nomeInicial?: string | null;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  id?: string;
}

/** Fornecedor ativo por código, nome, CPF/CNPJ ou e-mail (GET /api/compras/fornecedores/lookup). */
export function FornecedorCombobox({
  placeholder = "Selecione o fornecedor...", nomeInicial, ...props
}: FornecedorComboboxProps) {
  const itemInicial = props.value && nomeInicial
    ? { id: props.value, codigo: String(props.value), descricao: nomeInicial }
    : null;
  return (
    <EntityCombobox<LookupItem>
      {...props}
      itemInicial={itemInicial}
      queryKey="fornecedor-lookup"
      buscar={(termo) => buscarLookup(`${BASE}/lookup`, termo)}
      obterPorId={obterFornecedor}
      getId={(f) => f.id}
      getCodigo={(f) => f.codigo}
      getDescricao={(f) => f.descricao}
      getExtra={(f) => f.extra}
      placeholder={placeholder}
      placeholderBusca="Buscar por código, nome ou CPF/CNPJ..."
    />
  );
}
